import Calendar from './events';

const calendarElement = document.querySelector('[data-js-module="o-events-calendar"]');

if (calendarElement) {
  const calendar = new Calendar(calendarElement);
}
